/**
 * `InFlightRequests` se movió a `service/shared/` porque ya no es solo de
 * desempeño (lo usan el Inicio y `RewardsService`). Este re-export mantiene los
 * imports del módulo sin tocarlos.
 */
export { InFlightRequests } from "../shared/in-flight-requests";
